import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { archiveEventsRequest, getEventLogsRequest, getEventTypesRequest } from 'api/requests/api-errors-requests';
import { UPDropdownItem } from 'components/dropdown';
import {
  EVENT_LOG__ARCHIVE_SELECTED,
  EVENT_LOG__GET_ALL,
  EVENT_LOG__GET_ALL_ERROR,
  EVENT_LOG__GET_ALL_LOADING,
  EVENT_LOG__GET_ALL_SUCCESS,
  EVENT_LOG__GET_ERROR_TYPES,
  EVENT_LOG__SET_ALL,
  EVENT_LOG__SET_ERROR_TYPES,
} from 'store/constants';
import { IApiError } from 'types/errors';
import { ApiErrorFilters } from 'types/errors/ApiErrorFilters';
import { PaginatedList } from 'types/PaginatedList';

export const getApiErrorsLoadingAction = createAction<boolean>(EVENT_LOG__GET_ALL_LOADING);
export const getApiErrorsSuccessAction = createAction<boolean>(EVENT_LOG__GET_ALL_SUCCESS);
export const getApiErrorsErrorAction = createAction<boolean>(EVENT_LOG__GET_ALL_ERROR);
export const setApiErrorsAction = createAction<PaginatedList<IApiError>>(EVENT_LOG__SET_ALL);

export const getEventsAction = createAsyncThunk(EVENT_LOG__GET_ALL, async (filters: ApiErrorFilters, { dispatch }) => {
  dispatch(getApiErrorsLoadingAction(true));
  dispatch(getApiErrorsSuccessAction(false));
  dispatch(getApiErrorsErrorAction(false));

  try {
    const response = await getEventLogsRequest(filters);
    dispatch(setApiErrorsAction(response));
    dispatch(getApiErrorsSuccessAction(true));
  } catch {
    dispatch(getApiErrorsErrorAction(true));
    dispatch(
      setApiErrorsAction({
        items: [],
        pageIndex: 0,
        numberOfResults: 0,
        pageSize: 0,
        totalPages: 0,
      }),
    );
  }

  dispatch(getApiErrorsLoadingAction(false));
});

export const setApiErrorTypesAction = createAction<UPDropdownItem[]>(EVENT_LOG__SET_ERROR_TYPES);

export const getErrorTypesAction = createAsyncThunk(EVENT_LOG__GET_ERROR_TYPES, async (_, { dispatch }) => {
  dispatch(getApiErrorsLoadingAction(true));
  try {
    const response = await getEventTypesRequest();
    dispatch(setApiErrorTypesAction(response));
  } catch (error) {
    dispatch(getApiErrorsErrorAction(true));
  }
  dispatch(getApiErrorsLoadingAction(false));
});

export const archiveErrorsAction = createAsyncThunk(
  EVENT_LOG__ARCHIVE_SELECTED,
  async (errorIds: number[], { dispatch }) => {
    dispatch(getApiErrorsLoadingAction(true));
    dispatch(getApiErrorsErrorAction(false));

    try {
      await archiveEventsRequest(errorIds);
    } catch (error) {
      dispatch(getApiErrorsErrorAction(true));
    }

    dispatch(getApiErrorsLoadingAction(false));
  },
);
